import type {YoutubeChannel} from "@/models/youtube_channel";
import axiosInstance from "@/utils/axiosInstance";

class YoutubeChannelService {
  private readonly baseURL = "/apps/youtube/channels"

  async list(): Promise<YoutubeChannel[]> {
    const {data} = await axiosInstance.get(this.baseURL)
    return data;
  }

  async get(channelID: string): Promise<YoutubeChannel> {
    const {data} = await axiosInstance.get(`${this.baseURL}/${channelID}`)
    return data;
  }
}

export default new YoutubeChannelService()
